export default __webpack_public_path__ + "static/media/drprado3x.9a52b012.png";